import { register } from '@shopify/theme-sections';
import ProductVariants from '../components/ProductVariants';
import QuickAdd from '../components/QuickAdd';

register('product-grid', {
  initCards() {
    const productCards = this.container.querySelectorAll('[data-product-card]');
    if (!productCards) return;

    productCards.forEach((card) => {
      let productCardItem = new ProductVariants(card);

      this.initCard(productCardItem);
    });
  },

  initCard(productCardItem) {
    let timespend = 0;
    const quickAdd = new QuickAdd(productCardItem.el);
    let waitVariantsData = setInterval(() => {
      timespend = timespend + 2;
      if (productCardItem.allProductStyles != undefined) {
        let renderedItems = 0;
        let currentItemFounded = false;
        let renderedBadge = productCardItem.buildBadge(
          productCardItem.badgeTags,
        );
        renderedBadge
          ? productCardItem.el
              .querySelector('.product-card__image [data-product-link]')
              .appendChild(renderedBadge)
          : null;
        clearInterval(waitVariantsData);
        for (const product in productCardItem.allProductStyles.products) {
          let swatchProduct =
            productCardItem.allProductStyles.products[product];
          let swatchItem = productCardItem.buildSwatchItem(swatchProduct);
          if (swatchItem) {
            if (
              productCardItem.el.querySelector('[data-color-swatches]') != null
            ) {
              let currentItem =
                productCardItem.data.id == swatchProduct.id ? true : false;
              if (currentItem) {
                swatchItem.classList.add('selected');
                productCardItem.el
                  .querySelector('[data-color-swatches]')
                  .prepend(swatchItem);
                currentItemFounded = true;
                quickAdd.buildQuickAdd(swatchProduct);
              } else {
                if (renderedItems < 6) {
                  productCardItem.el
                    .querySelector('[data-color-swatches]')
                    .appendChild(swatchItem);
                  renderedItems++;
                }
              }
            }
            swatchItem.addEventListener('click', (e) => {
              e.preventDefault();
              if (e.currentTarget.classList.contains('selected')) {
                return false;
              }
              let itemTrack = {
                Name: swatchProduct.title,
                ProductID: swatchProduct.id,
                Categories: swatchProduct.categories,
                ImageURL: swatchProduct.featuredImage,
                URL: 'https://reef-admin.myshopify.com' + swatchProduct.url,
                Brand: swatchProduct.vendor,
                Price: swatchProduct.formattedPrice,
                CompareAtPrice: swatchProduct.formattedCompareAtPrice,
              };
              _learnq.push(['track', 'Viewed Product', itemTrack]);
              _learnq.push([
                'trackViewedItem',
                {
                  Title: itemTrack.Name,
                  ItemId: itemTrack.ProductID,
                  Categories: itemTrack.Categories,
                  ImageUrl: itemTrack.ImageURL,
                  Url: itemTrack.URL,
                  Metadata: {
                    Brand: itemTrack.Brand,
                    Price: itemTrack.Price,
                    CompareAtPrice: itemTrack.CompareAtPrice,
                  },
                },
              ]);
              quickAdd.buildQuickAdd(swatchProduct);
              productCardItem.el
                .querySelector('[data-main-image]')
                .setAttribute('src', swatchProduct.images[0]);
              productCardItem.el
                .querySelector('[data-main-image]')
                .setAttribute(
                  'srcset',
                  productCardItem.buildSrcSet(swatchProduct.images[0]),
                );
              productCardItem.el
                .querySelector('[data-secondary-image]')
                .setAttribute('src', swatchProduct.images[1]);
              productCardItem.el
                .querySelector('[data-secondary-image]')
                .setAttribute(
                  'srcset',
                  productCardItem.buildSrcSet(swatchProduct.images[1]),
                );
              let links = productCardItem.el.querySelectorAll(
                '[data-product-link]',
              );
              let chip = productCardItem.el.querySelector(
                '[data-product-chip]',
              );
              if (chip) {
                if (swatchProduct?.chip?.length > 0) {
                  chip.style.display = 'flex';
                  let chipHtml = '';
                  swatchProduct?.chip?.forEach((chipItem) => {
                    chipHtml += `<p class="${this.type}__chip--item">${chipItem}</p>`;
                  });
                  chip.innerHTML = chipHtml;
                } else {
                  chip.style.display = 'none';
                }
              }
              links.forEach((link) => {
                link.setAttribute('href', swatchProduct.url);
              });

              let newPromo = swatchProduct.plpPromoMessage;
              let newPromoColor = swatchProduct.plpPromoMessageColor;
              let newPromoBold = swatchProduct.plpPromoMessageBold;
              let newPromoItalic = swatchProduct.plpPromoMessageItalic;
              if (!productCardItem.el.querySelector('.promotion-text')) {
                const titleLink = productCardItem.el.querySelector(
                  '.product-card__title--link',
                );
                const newNode = document.createElement('span');
                newNode.classList.add('promotion-text');
                titleLink.insertBefore(newNode, titleLink.children[0]);
              }
              const promoText =
                productCardItem.el.querySelector('.promotion-text');
              if (newPromo != null) {
                promoText.textContent = newPromo;
                promoText.style.display = 'block';
                if (newPromoColor) {
                  promoText.style.color = newPromoColor;
                } else {
                  promoText.style.color = null;
                }
                if (newPromoBold) {
                  promoText.style.fontWeight = 'bold';
                } else {
                  promoText.style.fontWeight = null;
                }
                if (newPromoItalic) {
                  promoText.style.fontStyle = 'italic';
                } else {
                  promoText.style.fontStyle = null;
                }
              } else {
                productCardItem.el;
                promoText.style.display = 'none';
              }

              productCardItem.el.querySelector(
                '[data-product-title]',
              ).textContent = swatchProduct.title;
              productCardItem.el.querySelector(
                '[data-product-price]',
              ).textContent = swatchProduct.formattedPrice;
              if (
                swatchProduct.formattedCompareAtPrice &&
                swatchProduct.formattedCompareAtPrice !=
                  swatchProduct.formattedPrice
              ) {
                productCardItem.el
                  .querySelector('[data-product-price]')
                  .classList.add('price-item--sale--with');
                productCardItem.el.querySelector(
                  '[data-product-compare]',
                ).textContent = swatchProduct.formattedCompareAtPrice;
              } else {
                productCardItem.el
                  .querySelector('[data-product-price]')
                  .classList.remove('price-item--sale--with');
                productCardItem.el.querySelector(
                  '[data-product-compare]',
                ).textContent = '';
              }
              productCardItem.el
                .querySelector('.selected[data-product-swatch]')
                .classList.remove('selected');
              e.currentTarget.classList.add('selected');
            });
            if (renderedItems == 6 && currentItemFounded) {
              let swatchItemMore = productCardItem.buildSwatchItem(
                productCardItem,
                productCardItem.allProductStyles.products.length,
              );
              productCardItem.el
                .querySelector('[data-color-swatches]')
                .appendChild(swatchItemMore);
              break;
            }
          }
        }
      } else {
        if (timespend > 10000) {
          clearInterval(waitVariantsData);
        }
      }
    }, 2);
  },

  onLoad: function (e) {
    this.initCards();
  },
});
